"use client";




export default function Cta() {
  return (
    <section className="w-full py-12 lg:py-[4.5rem]">
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-8 px-5 md:px-8 lg:px-0">
        <div className="mb-6 text-center relative flex flex-col items-center">
          <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
            <span className="block w-40 h-40 rounded-full bg-gradient-to-tr from-[#29c26b]/20 via-[#dd00f3]/10 to-transparent blur-2xl opacity-80 animate-pulse"></span>
          </div>
          <div className="relative z-10 inline-flex items-center gap-3 justify-center">
            <span className="inline-block bg-gradient-to-tr from-[#29c26b] via-[#dd00f3] to-[#29c26b] bg-clip-text text-transparent text-4xl sm:text-5xl tracking-tight drop-shadow-lg lg:text-[3.6rem] font-medium dark:text-[#188fbf]">
              FAQ
            </span>
          </div>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto mt-4">
            Learn about how our ESIM plans works and why you should use it!
          </p>
        </div>
        {/* General FAQ Section */}
        <div className="bg-card rounded-lg shadow-sm p-6">
          <h3 className="text-2xl font-semibold mb-4 text-card-foreground">
            <span className="lg:text-[2rem] dark:text-[#c8eb7c]">
              General Questions
            </span>
          </h3>
          <div className="space-y-4">
            <div>
              <div className="font-medium text-lg text-card-foreground">
                <span className="lg:text-[1.25rem] dark:text-[#ffffff]">
                  What is a crypto-only ESIM?
                </span>
              </div>
              <div className="text-card-foreground mt-1">
                <span className="dark:text-[#29c26b]">
                  Our ESIM lets you pay and activate your cellular plan using
                  cryptocurrency, therefor staying Anonymous for optimal privacy
                  online.
                </span>
              </div>
            </div>
            <div>
              <div className="font-medium text-lg text-card-foreground">
                <span className="dark:text-[#ffffff]">Why switch to ESIM?</span>
              </div>
              <div className="text-card-foreground mt-1">
                <span className="dark:text-[#29c26b] lg:text-[1rem] font-normal">
                  In today's age there is now no need for a physical SIM card
                  that needs to be changed out frequently or has a higher chance
                  of being targeted for scam calls and other malicious activity.
                  AetherSIM can guarantee our customers privacy for a
                  competitive price and better experience overall. As we move
                  forward the goal is to have AetherSIM available virtually
                  everywhere on the globe for the most affordable prices.
                </span>
              </div>
            </div>
            <div>
              <div className="font-medium text-lg text-card-foreground"></div>
              <div className="text-card-foreground mt-1">
                <span className="dark:text-[#29c26b]"></span>
              </div>
            </div>
          </div>
        </div>

        {/* Security & Privacy Section */}
        <div className="bg-card rounded-lg shadow-sm p-6">
          <h3 className="text-2xl font-semibold mb-4 text-card-foreground">
            <span className="lg:scale-[2.90] lg:text-[2rem] dark:text-[#c8eb7c]">
              Security & Privacy
            </span>
          </h3>
          <div className="space-y-4">
            <div>
              <div className="font-medium text-lg text-card-foreground">
                <span className="dark:text-[#ffffff]">
                  How is my privacy protected?
                </span>
              </div>
              <div className="text-card-foreground mt-1">
                <span className="dark:text-[#29c26b]">
                  We never require personal info beyond what's needed for ESIM
                  activation. All payments are processed securely on-chain, and
                  no payment data is stored on our servers. No Passport or ID
                  card is needed. Simply sign up with a valid email address. The
                  provided Residential Privacy IP hides your real IP location.
                </span>
              </div>
            </div>
            <div>
              <div className="font-medium text-lg text-card-foreground"></div>
              <div className="text-card-foreground mt-1"></div>
            </div>
            <div>
              <div className="font-medium text-lg text-card-foreground"></div>
              <div className="text-card-foreground mt-1"></div>
            </div>
          </div>
        </div>

        {/* Activation & Setup Section */}
        <div className="bg-card rounded-lg shadow-sm p-6">
          <h3 className="text-2xl font-semibold mb-4 text-card-foreground">
            <span className="lg:text-[2rem] dark:text-[#c8eb7c]">
              Activation & Setup
            </span>
          </h3>
          <div className="space-y-4">
            <div>
              <div className="font-medium text-lg text-card-foreground">
                <span className="font-medium dark:text-[#ffffff] lg:text-[1rem]">
                  How do I activate my ESIM?
                </span>
              </div>
              <div className="text-card-foreground mt-1">
                <span className="dark:text-[#29c26b] lg:text-[1rem]">
                  Choose your Esim, pay with your preferred cryptocurrency, and
                  you’ll receive your ESIM profile by email within minutes. Scan
                  the QR code or manually enter the activation details on your
                  device.
                </span>
              </div>
            </div>
            <div>
              <div className="font-medium text-lg text-card-foreground"></div>
              <div className="text-card-foreground mt-1"></div>
            </div>
            <div>
              <div className="font-medium text-lg text-card-foreground">
                <span className="font-medium dark:text-[Apple i] dark:text-[#ffffff]">
                  Can I use my ESIM immediately?
                </span>
              </div>
              <div className="text-card-foreground mt-1">
                <span className="dark:text-[#29c26b]">
                  Yes! Activation is instant after payment confirmation. You’ll
                  be ready to connect worldwide within minutes.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
